import React from 'react';

const TableInfo = ({ handleClose }) => {
  return (
    <div className=''>
      <div className='modal-main'>
        <button
          className='ui right floated button red modal-close'
          onClick={handleClose}
        >
          X
        </button>
        <table className='ui celled table'>
          <thead>
            <tr>
              <th>Field Name</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label='Field Name'>Culture Name</td>
              <td data-label='Description'>
                Wherever possible, we have tried to use the conventional name
                for the culture.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Start Date</td>
              <td data-label='Description'>
                Start date for range dates. If there is only one year, start and
                end dates will be same. (9999 for Unknown and 8888 for NULL
                values)
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>End Date</td>
              <td data-label='Description'>
                End date for range dates. If there is only one year, start and
                end dates will be same. (9999 for Unknown and 8888 for NULL
                values)
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Community Name</td>
              <td data-label='Description'>
                If the focus is a community (band, hamlet, neighborhood,
                village), the name is given here if known.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>District Name</td>
              <td data-label='Description'>
                If the community is located in a known district, the name is
                given here.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Focus Note</td>
              <td data-label='Description'>Focus note.</td>
            </tr>
            <tr>
              <td data-label='Field Name'>Region Code</td>
              <td data-label='Description'>Region code for the focus.</td>
            </tr>
            <tr>
              <td data-label='Field Name'>Culture Area</td>
              <td data-label='Description'>Culture area for the focus.</td>
            </tr>
            <tr>
              <td data-label='Field Name'>Countries</td>
              <td data-label='Description'>Country list for the focus.</td>
            </tr>
            <tr>
              <td data-label='Field Name'>Population</td>
              <td data-label='Description'>
                Population for the focus (thousand).
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Population Year</td>
              <td data-label='Description'>Population year for the focus.</td>
            </tr>
            <tr>
              <td data-label='Field Name'>Population Note</td>
              <td data-label='Description'>Population note.</td>
            </tr>
            <tr>
              <td data-label='Field Name'>Language Name</td>
              <td data-label='Description'>
                The language name is obtained from Ethnologue. When the project
                was started, reference was made to the 10th edition (Grimes
                1984); more recently we have used 11th edition (Grimes 1988).
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Language Code</td>
              <td data-label='Description'>
                The three letter code for language from Ethnologue. Each code
                designates a unique language.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Language Note</td>
              <td data-label='Description'>
                Comments or problems with language.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>SCCS ID</td>
              <td data-label='Description'>
                The ID number in the SCCS (from 001-186).
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>SCCS Name</td>
              <td data-label='Description'>
                The name of the society as it appears in the SCCS.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>SCCS Date</td>
              <td data-label='Description'>
                The ethnographic present that appears in the SCCS.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>SCCS Note</td>
              <td data-label='Description'>
                Comments or problems with the concordance.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>EA ID</td>
              <td data-label='Description'>
                The alphanumeric identification number given in the Atlas. All
                numerals were changed to two digits (e.g., Aa1 becomes Aa01).
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>EA Name</td>
              <td data-label='Description'>
                The name of the society as it appears in the Atlas.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>EA Date</td>
              <td data-label='Description'>
                The ethnographic present that appears in the Atlas.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>EA Note</td>
              <td data-label='Description'>
                Comments or problems with the concordance.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>EA Summary ID</td>
              <td data-label='Description'>
                The alphanumeric identification number given in the Atlas
                summary. All numerals were changed to two digits (e.g., Aa1
                becomes Aa01).
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>EA Summary Name</td>
              <td data-label='Description'>
                The name of the society as it appears in the Atlas summary.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>EA Summary Date</td>
              <td data-label='Description'>
                The ethnographic present that appears in the Atlas.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>EA Summary Note</td>
              <td data-label='Description'>
                Comments or problems with the concordance.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>AWC ID</td>
              <td data-label='Description'>
                The alphanumeric identification number given in the AWC.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>AWC Name</td>
              <td data-label='Description'>
                The name of the society as it appears in the AWC.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>AWC Date</td>
              <td data-label='Description'>
                The ethnographic present that appear in the AWC.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>AWC Note</td>
              <td data-label='Description'>
                Comments or problems with the concordance.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>SRS</td>
              <td data-label='Description'>
                1 if sample in the focus and 0 if sample is not in the focus.
                Since all these cases are in Fiche (and eHRAF), the reader
                should look at the Fiche (and eHRAF) fields for the appropriate
                information.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>PSF Cluster No</td>
              <td data-label='Description'>
                The number of the cluster (culture area) that the society falls
                in.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>PSF Cluster Name</td>
              <td data-label='Description'>The name of the cluster.</td>
            </tr>
            <tr>
              <td data-label='Field Name'>SES Name</td>
              <td data-label='Description'>
                The name of the society in the SES.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Fiche ID</td>
              <td data-label='Description'>
                If there are some sources that match the focus for the case, the
                HRAF identification number (OWC or Outline of World Cultures
                number; OWC no.) is given for those files currently in the
                archive.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Fiche Name</td>
              <td data-label='Description'>
                The name of the HRAF file is given here. Since HRAF tends to
                have comprehensive files, that is, sources that span different
                time periods and different places, the name is often more
                general than the typical cross-cultural sample name.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Fiche Source</td>
              <td data-label='Description'>
                The source numbers in HRAF that clearly match the focus are
                provided here. The user should keep in mind that other sources
                in HRAF (not mentioned here) might give appropriate information
                (e.g., if a later source gives historical information in a
                chapter). These source guides are intended to provide the best
                matches. Source numbers are given with the word “partial” or
                “caution” in parentheses. “Partial” refers to the fact that the
                source might contain only certain chapters that match, or that
                the source discusses several foci. If the word “caution” is
                used, it is probably either because the time focus or place
                focus is uncertain, or the source moves from one focus to
                another without that much clarity.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>Fiche Note</td>
              <td data-label='Description'>
                Comments or problems on the matching sources.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>eHRAF ID</td>
              <td data-label='Description'>
                If there are some sources that match the focus for the case, the
                HRAF identification number (OWC or Outline of World Cultures
                number; OWC no.) is given for those files currently in the eHRAF
                World Cultures database.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>eHRAF Name</td>
              <td data-label='Description'>
                The name of the eHRAF file is given here. Since eHRAF tends to
                have comprehensive files, that is, sources that span different
                time periods and different places, the name is often more
                general than the typical cross-cultural sample name.
              </td>
            </tr>
            <tr>
              <td data-label='Field Name'>eHRAF Source</td>
              <td data-label='Description'>
                The source numbers in eHRAF World Culture that clearly match the
                focus are provided here. The user should keep in mind that other
                sources in eHRAF WC (not mentioned here) might give appropriate
                information (e.g., if a later source gives historical
                information in a chapter). These source guides are intended to
                provide the best matches. Source numbers are given with the word
                “partial” or “caution” in parentheses. “Partial” refers to the
                fact that the source might contain only certain chapters that
                match, or that the source discusses several foci. If the word
                “caution” is used, it is probably either because the time focus
                or place focus is uncertain, or the source moves from one focus
                to another without that much clarity.
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colSpan='2'>
                <button
                  className='ui left floated button red'
                  onClick={handleClose}
                >
                  Close
                </button>
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default TableInfo;
